import React from 'react';
import { Badge } from './ui/badge';

const STYLES = {
  draft: 'border-slate-300 text-slate-700 bg-slate-50',
  error: 'border-red-300 text-red-700 bg-red-50',
  rejected: 'border-red-300 text-red-700 bg-red-50',
  sent: 'border-blue-300 text-blue-700 bg-blue-50',
  delivered: 'border-emerald-300 text-emerald-800 bg-emerald-50',
  not_delivered: 'border-amber-300 text-amber-800 bg-amber-50',
};
const LABELS = {
  draft: 'Bozza', error: 'Errore invio', rejected: 'Scartata SDI', sent: 'Inviata',
  delivered: 'Consegnata', not_delivered: 'Mancata consegna',
};

export const InvoiceStatusBadge = ({ status, testId }) => (
  <Badge data-testid={testId} variant="outline" className={STYLES[status] || STYLES.draft}>
    {LABELS[status] || status}
  </Badge>
);

export const openBlob = (data, type, filename) => {
  const url = window.URL.createObjectURL(new Blob([data], { type }));
  if (filename) {
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
  } else {
    window.open(url, '_blank');
  }
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export default InvoiceStatusBadge;
